import axios from "./axiosInstance";
import { USE_MOCK_API } from "../config/apiConfig";
import mockWishlistAPI from "../mocks/services/mockWishlistAPI";

const wishlistAPI = {
  listing: () => axios.post(`wishlists`),
  addProduct: (payload) => axios.post(`wishlists/add`, payload),
};

// export default wishlistAPI;
export default USE_MOCK_API
    ? mockWishlistAPI
    : wishlistAPI;
